exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filters[data-v-78574098]{border:1px solid #d3d3d3;padding:6px 20px;border-radius:0}.filters .search-bar input[data-v-78574098]{border:none;font-size:12px;outline:none;box-shadow:none}.filters .search-bar button.btn[data-v-78574098]{color:inherit;background:none;border:none}.filters .filters-toggle a[data-v-78574098]{font-size:12px}.filters form[data-v-78574098]{margin-top:10px}.tabs[data-v-78574098]{background-color:#008bd0;width:100%;border-radius:15px 15px 0 0;overflow:hidden}.tabs .tab[data-v-78574098]{padding:15px 20px;text-align:center;text-transform:uppercase;color:#008bd0;font-size:13px;opacity:.5;cursor:pointer}.tabs .tab.active[data-v-78574098]{color:#008bd0;opacity:1;background-color:#fff;border-radius:15px 15px 0 0;box-shadow:0 0 10px 0 rgba(0,0,0,.1)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-78574098","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Global/AdminTableSync.vue
// module id = 636
// module chunks = 0